import PlatformTargeting from './platform-targeting';

export default PlatformTargeting;